/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/core';

import template from './tfa-recovery-page.component.html';
import {TwoFactorAuthRecoveryResource} from '../../../components/api/resources/resource/two-factor-auth-recovery';

@Component({
  standalone: false,
  selector: 'adn-tfa-recovery-page',
  template
})
export class TfaRecoveryPageComponent implements OnInit {
  verifyCompleted = false;
  alreadyCompleted = false;
  verifyProcess = false;
  verifyCode: string | null = null;
  userNotFound = false;
  errorMessage: string | null = null;
  user: any = null;

  constructor(
    @Inject(TwoFactorAuthRecoveryResource) private readonly twoFactorAuthRecoveryResource: any,
    private readonly uiRouter: UIRouter
  ) {
  }

  ngOnInit(): void {
    this.twoFactorAuthRecoveryResource.getRecoveryUser(this.uiRouter.globals.params.userId).then((page: any) => {
      if (page.status === 404) {
        this.userNotFound = true;
      } else if (page.status === 400) {
        this.alreadyCompleted = true;
        this.errorMessage = page.data.text;
      } else {
        this.user = page;
        this.verifyProcess = true;
      }
    });
  }

  verify(): void {
    this.errorMessage = null;
    this.twoFactorAuthRecoveryResource.submitVerifiedUser(this.user.id, this.verifyCode).then((result: any) => {
      if (result === true) {
        this.verifyCompleted = true;
        this.verifyProcess = false;
      } else {
        this.errorMessage = result.text;
      }
    });
  }
}
